<template>
  <div>
    <div class="box-form-result">
      <div class="d-flex">
        <div class="font-weight-bold">Phạm vi:</div>
        <div class="ml-3 mb-3">
          <div
            v-for="(item, index) in chiTietPhanQuyen.listPhamVi"
            :key="index"
          >
            {{ item.moTaLevel || item.donVi || item.moTaLevel }}
          </div>
        </div>
      </div>
      <DataTable
        :value="danhSachQuyenNoiBo"
        :loading="isLoadingTable"
        :selection.sync="selectedPermission"
      >
        <Column
          field="id"
          headerStyle="width: 40px"
          header=""
          bodyStyle="text-align: center"
          selectionMode="multiple"
          :filter-header-class="readonly ? 'd-none' : ''"
          :body-class="readonly ? 'd-none' : ''"
          :header-class="readonly ? 'd-none p-2' : 'p-2'"
        >
        </Column>
        <Column
          field="stt"
          dataKey="stt"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #filter> </template>
          <template #body="slotProps">
            <span>{{
              (requestInformation.pageIndex - 1) * requestInformation.pageSize +
              slotProps.index +
              1
            }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="displayName"
          header="Mã quyền"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.PermissionCode"
              @change="timDanhSachQuyen"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.displayName }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="name"
          header="Tên quyền"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.PermissionName"
              @change="timDanhSachQuyen"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.name }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          headerStyle="width: 100px"
        >
          <template #body="slotProps">
            <div class="text-center">
              <b-icon
                icon="plus-circle-fill"
                variant="success"
                v-b-popover.hover.top="'Áp dụng phạm vi quyền'"
                class="cursor-pointer color-red ml-2"
                @click="themTungQuyen(slotProps.data.id)"
              />
            </div>
          </template>
        </Column>
        <template #empty
          ><div class="text-center">Không có dữ liệu</div></template
        >
        <template #loading
          ><div class="text-center">Đang tải dữ liệu ...</div>
        </template>
      </DataTable>
      <BasePagination
        class="mt-3"
        :current-page="requestInformation.pageIndex"
        :total-pages="danhSachQuyen.totalPage"
        :total-rows="danhSachQuyen.totalCount"
        @changeNum="onChangeNum($event)"
        @changePages="onChangePages($event)"
      />
    </div>
    <div class="d-flex justify-content-end mt-3">
      <base-button
        :disabled="selectedPermission.length === 0"
        class="btn search-information-btn mr-2"
        @click="themDanhSachQuyenDaChon()"
        button="Xác nhận"
      >
        Thêm quyền đã chọn
      </base-button>
      <base-button @click="hideModal()" button="Đóng"> </base-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import { BANG_DANH_SACH_QUYEN } from "@/constants/constants";

import _isNil from "lodash/isNil";
import BasePagination from "@/components/common/BasePagination";

export default {
  name: "DanhSachQuyenKhongThuocNguoiDung",
  components: {
    BasePagination,
  },
  data() {
    return {
      danhSachQuyenTrongNguoiDung: [],
      danhSachQuyenNoiBo: [],
      isLoadingTable: false,
      allPermissions: false,
      deletePermissionIds: [],
      NguoiDungId: null,
      danhSachIdQuyenDaChon: [],
      danhSachIdQuyen: [],
      selectAllRowsInPage: false,
      requestInformation: {
        pageIndex: 1,
        pageSize: 10,
        isGetAll: false,
        filterBy: "",
      },
      emptyHeaderTable: [
        BANG_DANH_SACH_QUYEN.stt,
        BANG_DANH_SACH_QUYEN.name,
        BANG_DANH_SACH_QUYEN.displayName,
        BANG_DANH_SACH_QUYEN.appName,
        BANG_DANH_SACH_QUYEN.thaoTac,
      ],
      selectedPermission: [],
    };
  },
  props: {
    actorId: {
      type: String,
      required: true,
    },
    actorType: {
      type: String,
      required: true,
    },
    chiTietPhanQuyen: {
      type: String,
      required: true,
    },
    readonly: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Boolean | null,
      required: false,
    },
    appId: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  created() {
    this.layDanhSachQuyenTrongHeThong();
  },
  computed: {
    ...mapGetters({
      danhSachQuyen: "permission/danhSachQuyenTrongAppPaging",
    }),
    hasPageData() {
      return !_isEmpty(this.danhSachQuyen);
    },
    danhSachQuyenDaChon: {
      get: function () {
        let danhSachQuyen = this.danhSachQuyenNoiBo.filter((quyen) =>
          this.danhSachIdQuyenDaChon.includes(quyen.Id)
        );

        return (danhSachQuyen.items || []).map((quyenDaChon, index) => {
          return Object.assign({}, quyenDaChon, {}, { stt: index + 1 });
        });
      },
      set: function () {},
    },
  },
  watch: {
    danhSachQuyen: {
      handler() {
        this.danhSachQuyenNoiBo = this.layDanhSachQuyenNoiBo(
          this.danhSachQuyen
        );
        this.danhSachIdQuyen = this.layDanhSachIdQuyen(this.danhSachQuyenNoiBo);
        this.clickSelectAllRowInPage();
      },
      immediate: true,
    },
    selectAllRowsInPage: {
      handler() {
        this.clickSelectAllRowInPage();
      },
    },
  },
  methods: {
    hideModal() {
      this.$emit("hideModal");
    },
    layDanhSachIdQuyen(danhSachQuyen) {
      if (_isEmpty(danhSachQuyen)) {
        return [];
      }
      return danhSachQuyen.map((item) => item.id);
    },
    themDanhSachQuyenDaChon() {
      this.permissionIds = this.selectedPermission.map((x) => x.id);
      this.themQuyenVaoNguoiDung();
    },
    themTungQuyen(id) {
      this.permissionIds = [id];
      this.themQuyenVaoNguoiDung();
    },
    themQuyenVaoNguoiDungThanhCong() {
      this.layDanhSachQuyenTrongHeThong();
    },
    themQuyenVaoNguoiDung() {
      const $vm = this;
      let payload = {
        ActorId: this.actorId,
        ActorType: this.actorType,
        permissionIds: this.permissionIds,
        ActorMappingId: this.chiTietPhanQuyen.actorMappingId,
      };
      this.$store
        .dispatch("permission/configPhamViQuyen", payload)
        .then((res) => {
          $vm.permissionIds = [];
          $vm.selectedPermission = [];
          $vm.$toasted.clear();
          $vm.$toasted.global.showSuccessMessage({
            message: res.data.message,
          });
          $vm.$emit("themQuyenVaoNguoiDungThanhCong");
        })
        .catch((error) => {
          $vm.$toasted.clear();
          if (
            !_isEmpty(error.response) &&
            error.response.data.Errors.length > 0
          ) {
            $vm.$toasted.global.showErrorMessage({
              message: error.response.data.Errors[0].Description,
            });
          }
        });
    },
    timDanhSachQuyen() {
      this.layDanhSachQuyenTrongHeThong();
    },
    layDanhSachQuyenTrongHeThong() {
      this.danhSachIdQuyenDaChon = [];
      let payload = {
        ...this.requestInformation,
        appId: this.appId,
        permissionIdIgnore: this.chiTietPhanQuyen.permissionId,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("permission/layDanhSachQuyenTheoAppPaging", payload)
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachQuyenTrongHeThong();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachQuyenTrongHeThong();
    },
    layDanhSachQuyenNoiBo(danhSachQuyen) {
      if (_isEmpty(danhSachQuyen)) {
        return [];
      }
      return (danhSachQuyen.items || []).map((item) => {
        return {
          checkbox: null,
          id: _isNil(item) ? "" : item.id,
          name: _isNil(item) ? "" : item.name,
          displayName: _isNil(item) ? "" : item.displayName,
          appName: _isNil(item.appName) ? "" : item.appName,
          thaoTac: null,
        };
      });
    },
  },
};
</script>


